import { render, staticRenderFns } from "./complaintsRate.vue?vue&type=template&id=f7c6c936&scoped=true"
import script from "./complaintsRate.vue?vue&type=script&lang=js"
export * from "./complaintsRate.vue?vue&type=script&lang=js"
import style0 from "./complaintsRate.vue?vue&type=style&index=0&id=f7c6c936&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c6c936",
  null
  
)

export default component.exports